import React, { lazy, Suspense } from "react";
import { Link } from "gatsby";
import { Tabla } from "./Tabla";
import { Seo } from "../Layout/Seo";
import GatsbyImages from "../GatsbyImages";

import "./postPage.css";

const MoneyRecharge = lazy(() =>
  import("../MoneyRecharge").then((module) => ({
    default: module.MoneyRecharge,
  })),
);

const MoneyConvertor = lazy(() =>
  import("../MoneyConvertor").then((module) => ({
    default: module.MoneyConvertor,
  })),
);

const LiteYouTubeEmbed = lazy(() => import("react-lite-youtube-embed"));

const DateFormatter = ({ dateString, lang, title }) => {
  const [year, day, month] = dateString.split("/");
  const date = new Date(`${year}-${month}-${day}`);

  const options = { day: "2-digit", month: "long", year: "numeric" };
  const langFormat = lang === "es" ? "es-ES" : "en-GB";
  const format = new Intl.DateTimeFormat(langFormat, options)
    .format(date)
    .replace(" de 2", ", 2");

  return (
    <>
      {title} · {format}
    </>
  );
};

const PostPage = ({ pageContext, lang }, props) => {
  if (props.pageContext?.blog?.none) return <div>noPage</div>;
  const { blog, resultfooterpost } = pageContext;

  const footerpost = resultfooterpost.filter(
    ({ locale }) => locale === lang,
  )[0];

  const formatDate = (dateString) => {
    const [year, day, month] = dateString.split("/");
    const date = new Date(`${year}-${month}-${day}`);

    const options = { day: "2-digit", month: "long", year: "numeric" };
    const langFormat = lang === "es" ? "es-ES" : "en-GB";
    return new Intl.DateTimeFormat(langFormat, options)
      .format(date)
      .replace(" de 2", ", 2");
  };

  const goBackLink = lang === "en" ? "/en/blog/" : "/blog/";

  const canonicalUrl = {
    canonical: lang === "en" ? `/en/blog/${blog.path}/` : `/blog/${blog.path}/`,
    en: pageContext.langSwitchURL.en,
    es: pageContext.langSwitchURL.es,
    xDefault: `/blog/${blog.path}/`,
  };

  return (
    <Seo
      title={pageContext.blog.seoTitle}
      description={pageContext.blog.seoDescription}
      canonicalUrl={canonicalUrl}
    >
      <section className="section-block p-4 mt-4 article-body" id="post">
        <div className="container">
          <GatsbyImages
            src={blog.image.localFile.childImageSharp.gatsbyImageData}
            className="content-image-unic"
            ext={blog.image.localFile.ext}
            alt={blog.image.alternativeText}
            loading="eager"
          />
          <div className="post-header">
            <Link to={goBackLink} className="volver">
              <span></span>Volver
            </Link>
            <h1>{blog.title}</h1>
            <ul className="headpost">
              <li>
                <DateFormatter
                  title={blog.category.Title}
                  dateString={blog.date}
                />
              </li>
              <li>
                {blog.reading_time}‘<span></span>
              </li>
            </ul>
          </div>
          <div className="postdetail">
            <div className="indexing">
              <div className="indexlist">
                <div className="indextext">Índice</div>
                <Tabla content={blog.index} />
              </div>
            </div>
            <div className="post-item">
              <div className="col-12 ">
                {blog.text.map(({ text, component }, index) => {
                  if (component?.type === "YoutubeEmbed") {
                    return (
                      <Suspense
                        key={index}
                        fallback={
                          <div
                            className="iframe-crusted loading"
                            style={{
                              "--iframe-crusted_bg": "#113a4c",
                              minHeight: "192px",
                              maxHeight: "432px",
                              width: "100%",
                            }}
                          >
                            Cargando...
                          </div>
                        }
                      >
                        <div className="iframe-crusted">
                          {component.type === "YoutubeEmbed" && (
                            <LiteYouTubeEmbed
                              style={{ borderRadius: "8px" }}
                              {...component.props}
                            />
                          )}
                        </div>
                      </Suspense>
                    );
                  }
                  if (component && component?.type !== "YoutubeEmbed") {
                    const isCalculadora = component.props?.locationName;
                    return (
                      <Suspense
                        key={index}
                        fallback={
                          <div
                            className="iframe-crusted loading"
                            style={{
                              "--iframe-crusted_bg": isCalculadora
                                ? "#113a4c"
                                : "#59518e",
                              "--iframe-crusted_display": isCalculadora
                                ? "flex"
                                : "block",
                              "--iframe-crusted_padding": isCalculadora
                                ? "8px 24px"
                                : "4px 4px",
                              minHeight: "352px",
                            }}
                          >
                            Cargando...
                          </div>
                        }
                      >
                        <div
                          className="iframe-crusted"
                          style={{
                            "--iframe-crusted_bg": isCalculadora
                              ? "#113a4c"
                              : "#59518e",
                            "--iframe-crusted_display": isCalculadora
                              ? "flex"
                              : "block",
                            "--iframe-crusted_padding": isCalculadora
                              ? "8px 24px"
                              : "4px 4px",
                            minHeight: "352px",
                          }}
                        >
                          {component.type === "MoneyConvertor" && (
                            <MoneyConvertor {...component.props} />
                          )}
                          {component.type === "MoneyRecharge" && (
                            <MoneyRecharge {...component.props} />
                          )}
                        </div>
                      </Suspense>
                    );
                  }

                  if (text) {
                    return (
                      <div
                        className="color: #939393;"
                        key={index}
                        dangerouslySetInnerHTML={{ __html: text }}
                      />
                    );
                  }

                  return null;
                })}
                <div className="advertisment">{footerpost?.Text}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="cta">
        <div className="container">
          <div className="avail-in d-flex flex-wrap">
            <div className="service-in col-lg-7 col-md-12">
              <h4>
                {lang === "en"
                  ? "Send your money at the real market price with Sendity"
                  : "Envía tu dinero al precio real del mercado con Sendity"}
              </h4>
            </div>
            <div className="whatsapp col-lg-5 col-md-12">
              <Link to="/enviar-dinero">
                {lang === "en" ? "I'm in!" : "¡Me apunto!"}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="cards-block">
        <div className="container">
          <div className="cards-in">
            <h3>{lang === "en" ? "Read more" : "Seguir leyendo"}</h3>
            <div className="cards">
              <ul className="clearfix autoplay d-flex flex-wrap">
                {blog.blogsBelongTo.map(
                  ({ text, path, thumbnail, date, title }, index) => {
                    const match = /<p[^>]*>(.*?)<\/p>/i.exec(text);
                    const firstPContent = match ? match[0] : "";

                    const formattedDate = formatDate(date);
                    return (
                      <li className="" key={index}>
                        <Link
                          to={
                            lang === "en" ? `/en/blog/${path}` : `/blog/${path}`
                          }
                        >
                          <div className="cardWrapper">
                            <div className="card1">
                              <GatsbyImages
                                src={
                                  thumbnail.localFile.childImageSharp
                                    .gatsbyImageData
                                }
                                ext={thumbnail.localFile.ext}
                                className="content-image"
                                alt={thumbnail.alternativeText}
                              />
                              <div className="category">
                                <span>{blog.category.Title}</span>
                              </div>
                            </div>
                            <div className="card-content">
                              <span>{formattedDate}</span>
                              <h5>{title}</h5>
                              <div
                                className="card-text"
                                dangerouslySetInnerHTML={{
                                  __html: firstPContent,
                                }}
                              ></div>
                            </div>
                          </div>
                        </Link>
                      </li>
                    );
                  },
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Seo>
  );
};
export default PostPage;

// // urls calculadora
// //      <iframe
// //      name="sendity"
// //      src="https://www.sendity.com/calculadora/?country=marruecos&&lang=es"
// //    ></iframe>
// //       <iframe
// //      name="sendity"
// //      src="https://www.sendity.com/calculadora/?country=morocco&&lang=en"
// //    ></iframe>
// //       <iframe
// //      name="sendity"
// //      src="https://www.sendity.com/calculadora-recargas/?country=marruecos&&lang=es"
// //    ></iframe>

// //    <iframe
// //      name="sendity"
// //      src="https://www.sendity.com/calculadora-recargas/?country=republica-dominicana&&lang=es"
// //    ></iframe>
// // <iframe
// //      name="sendity"
// //      src="https://www.sendity.com/calculadora-recargas/?country=dominican-republic&&lang=en"
// //    ></iframe>
